import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from 'src/app/_shared/shared.service';
import { TkTableComponent } from 'src/app/_components/tk-table/tk-table.component';
import { TkTabsComponent } from 'src/app/_components/tk-tabs/tk-tabs.component';
import { TkTabComponent, TkTabBodyDirective } from 'src/app/_components/tk-tabs/tk-tab.component';
import { HttpPlus } from 'src/app/SayTS/http-plus';
import { Constants } from 'src/app/_consts/constants';
import { SGroup } from 'src/app/SayTS/objects/s-group';
import { User } from 'src/app/_models/user';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  imports: [NgbModule, TranslateModule, TkTableComponent, TkTabsComponent, TkTabComponent, TkTabBodyDirective]
})
export class UsersComponent implements OnInit {

  activeTab = this.shared.loadActiveTab("users_tab", false, 1)

  userCols = User.COLS;
  userRefreshUrl = "getUsers";
  userDetailUrl = "users";
  userDetailId = User.PRIMARY_KEY;

  groupCols = SGroup.COLS;
  groupRefreshUrl = "getGroups";
  groupDetailUrl = "groups";
  groupDetailId = SGroup.PRIMARY_KEY;

  constructor(protected router: Router, protected shared: SharedService, protected http: HttpPlus) {
    const col = SGroup.COLS.find(c => c.attr == 'module')
    if (col) {
      col.options = [
        {
          text: `modules.${Constants.MOD_BASE}`,
          value: Constants.MOD_BASE
        },
        ...Constants.APPS.map(a => {
          return {
            text: `modules.${a.code}`,
            value: a.code
          }
        })
      ]
    }
  }

  ngOnInit(): void {
  }

  createNew(): void {
    switch (this.activeTab) {
      case 1:
        this.router.navigate(['/users/new']);
        break;
      case 2:
        this.router.navigate(['/groups/new']);
        break;
      case 3:
        this.router.navigate(['/userTemplate/new']);
        break;
    }
  }

  tabChanged() {
    this.shared.saveActiveTab("users_tab", false, this.activeTab)
  }

  assignAll(rows) {
    rows.forEach(r => {
      if (r.module)
        r.module = this.shared.t(`modules.${r.module}`)
    });
  }

}
